import card1 from "../assets/images/Card1.png";
import card2 from "../assets/images/Card2.png";
import card3 from "../assets/images/Card3.png";
import card4 from "../assets/images/Card4.png";
import card5 from "../assets/images/Card5.png";

export const cardData = [
  {
    id: "1",
    name: "Artem",
    image: card1,
    status: "Online",
  },
  {
    id: "2",
    name: "Ahmad",
    image: card2,
    status: "Online",
  },
  {
    id: "3",
    name: "Niki",
    image: card3,
    status: "Offline",
  },
  {
    id: "4",
    name: "Kira",
    image: card4,
    status: "Online",
  },
  {
    id: "5",
    name: "Ana",
    image: card5,
    status: "Offline",
  },
];